import { registerArchetype } from './index.js';
import { applyDamage, computeDamage, livingEnemies, effectiveAtk, effectiveDef } from '../combat.js';
registerArchetype({
    id: 'aoe_nuke',
    apply: ({ state, source, params, rng }) => {
        const multiplier = params.multiplier ?? 0.6;
        const enemies = livingEnemies(state, source.side);
        const sourceRt = (source.side === 'A' ? state.sideA : state.sideB)[source.slot];
        for (const e of enemies) {
            const dmg = computeDamage(effectiveAtk(sourceRt) * multiplier, effectiveDef(e.runtime));
            applyDamage(state, source, { side: source.side === 'A' ? 'B' : 'A', slot: e.slot }, dmg, false, rng);
        }
    }
});
